import "./assets/main.scss";
import {RouterProvider, useLocation, useNavigate} from "react-router-dom";
import React, {useContext, useEffect} from "react";
import {router} from "./router";
import {Context} from "./index";
import {observer} from "mobx-react-lite";
import {SnackbarProvider} from 'notistack';

const App = observer(() => {
    return (
        <SnackbarProvider maxSnack={3}>
            <RouterProvider router={router}/>
        </SnackbarProvider>
    );
});

export default App;